import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IWorkflowCollectionState} from '@features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
import {
  ArchiveCaseCommand,
  CreateArrangementFromExistingCaseCommand, SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand,
  SyncParticipantsCommand,
  SyncProjectEntityToCompanyCommand
} from '@features/dac6-reporter/commands/dac6-reporter.command';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {takeUntil} from 'rxjs/operators';
import {BasketProvider} from '@shared/models/basket-provider';

@Injectable({
  providedIn: 'root',
})
export class CompareSummaryRuleWithPreviousVersionCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  constructor(
    private router: Router,
    private dialogService: DialogService,
    protected commandService: CommandService
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    let sourceType = command.fieldValues['SourceType'];
    const dialogModel = DialogModel.create('Compare with Previous Version', 'CompareSummaryRulesDialogComponent', {sourceType}, '500px', '500px');
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state.action === 'OK') {
        const comparisonParams = {
          currentSnapshotId: dialogModel.input['currentSnapshot'].id,
          sourceType: dialogModel.input['currentSnapshot'].sourceType,
          currentSnapshotDate: dialogModel.input['currentSnapshot'].publishDate,
          previousSnapshotId: dialogModel.input['previousSnapshot'].id,
          previousSnapshotDate: dialogModel.input['previousSnapshot'].publishDate,
          countryCode: dialogModel.input['country'].code,
          countryName: dialogModel.input['country'].displayName
        };
        if (sourceType === 'GMTSummaryRule') {
          this.router.navigate(['gmt/library/summary-rules/compare'], {queryParams: comparisonParams});
        }
        else {
          this.router.navigate(['dac6-reporter/summary-rules/compare'], {queryParams: comparisonParams});
        }
      }
    });
    return true;
  }
}
